import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import UISelect from 'UIComponents/input/UISelect';
import { isUngatedForNewEditorAccess } from 'FormsUI/selectors/Gates';
import ListingLibFilterWrapper from 'framework-listing-lib/filters/ListingLibFilterWrapper';
import useFormTypeFilter from '../hooks/useFormTypeFilter';
import { TABLE_FORM_TYPES } from '../constants';
import { formTypeToI18nText } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const FormTypeFilter = () => {
  const {
    currentValue,
    active,
    handleChange,
    handleClearFilter
  } = useFormTypeFilter();
  const ungatedForNewEditorAccess = useSelector(isUngatedForNewEditorAccess);
  const options = TABLE_FORM_TYPES.map(formType => {
    const text = formTypeToI18nText(formType, ungatedForNewEditorAccess);
    return {
      text,
      value: `${formType}`
    };
  });
  const ButtonContent = () => currentValue ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.frameworkTable.filters.formType.labelActive",
    options: {
      count: currentValue.length
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.frameworkTable.filters.formType.labelInActive"
  });
  return /*#__PURE__*/_jsx(ListingLibFilterWrapper, {
    active: active,
    onClearFilter: handleClearFilter,
    children: /*#__PURE__*/_jsx(UISelect, {
      buttonUse: "transparent",
      anchorType: "button",
      ButtonContent: ButtonContent,
      onChange: handleChange,
      options: options,
      value: currentValue,
      menuWidth: "auto",
      multi: true
    })
  });
};
export default FormTypeFilter;